<template>
    <div class="form-container">
        <h2 style="margin: 0 0 16px 0; color: var(--color-ds-primary);">Geocode Table</h2>
        <div class="form-section">
            <div class="form-group">
                <label>Action Name</label>
                <input type="text" placeholder="geocode table" v-model="actionName" />
            </div>
            <div class="form-group">
                <label>Model Name</label>
                <select v-model="selectedModel">
                    <option value="">Select Model</option>
                    <option v-for="model in props.models" :key="model.id" :value="model.name">
                        {{ model.name }}
                    </option>
                </select>
            </div>
            <div class="form-group">
                <label>Table Name</label>
                <select v-model="tableName">
                    <option value="">Select Table</option>
                    <option value="customers">customers</option>
                    <option value="facilities">facilities</option>
                    <option value="suppliers">suppliers</option>
                </select>
            </div>
            <button class="button button-full" @click="addWorkflowItem">Add Workflow Item</button>
        </div>
    </div>
</template>

<script setup>
import { ref, defineProps } from 'vue';
import { addWorkflowItem as addWorkflowItemUtil, createGeocodeTableWorkflowItem } from '../utils/workflowUtils';

const props = defineProps({
    models: Array
});

const actionName = ref('');
const selectedModel = ref('');
const tableName = ref('');

const addWorkflowItem = async () => {
    // Create the workflow item data
    const { keys, values } = createGeocodeTableWorkflowItem(
        actionName.value,
        selectedModel.value,
        tableName.value
    );

    // Add to workflow sheet using utility
    await addWorkflowItemUtil(keys, values);
};
</script>
